<div class="main-form" #pitchCardWrapper>
  <div class="forgot-password">
    <h1>Forgot your password?</h1>
    <h2>
      Don't worry. Resetting your password is easy, just tell us the email
      address you registered.
    </h2>
    <form (ngSubmit)="gotoOTP()" [formGroup]="forgotPasswordForm">
      <span class="p-float-label">
        <input
          id="userName"
          appNoLeadingSpace
          autocomplete="email"
          class="input-primary bg-transparent shadow-none"
          formControlName="userName"
          pInputText
          size="30"
          type="text"
        />
        <label for="userName" translate> label_email_address </label>
      </span>
      <div *ngIf="submitted && f.userName.errors" class="error-sign">
        <div
          *ngIf="forgotPasswordForm.controls.userName.errors.required"
          translate
        >
          err_required_emailId
        </div>
        <div
          *ngIf="forgotPasswordForm.controls.userName.errors.pattern"
          translate
        >
          err_invalid_emailId
        </div>
      </div>
      <div class="error-sign">
        {{ errorMessage }}
      </div>
      <button
        [disabled]="loading"
        class="button-simple lg-50 shock-pink"
        translate
      >
        label_send
      </button>
    </form>
  </div>
</div>
